import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import RelationshipModel from '../model/RelationshipModel'
import RelationshipForm from '../ui/RelationshipForm'

export default class EditRelationship {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.relationshipForm.getValue()
      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('relationships', this.data.getJSON()).then((relationship) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }
        
        if (args && !args.id && relationship.id) {
          window.PRIM.navigate('/relationships/' + relationship.id, true)
        }

        if (relationship) {
          this.data.values.id = relationship.id
          this.relationshipForm.setValue(this.data)
        }        
      })
    }

    this.data = new RelationshipModel()

    if (args) {
      if (args.id) {
        window.PRIM.dataAccess.resolve('relationships', args.id, true).then((relationship) => {
          this.data = relationship
          this.relationshipForm.setValue(this.data)
        }, () => {
          if (confirm('Deze relatie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw relatie aanmaken?')) {
            window.PRIM.navigate('/relationships/')
          } else {
            history.back()
          }
        }).catch(() => {
          alert('Fout')
        })
      } else if (args.person_id) {
        window.PRIM.dataAccess.resolve('people', args.person_id, true).then((person) => {
          this.data.values.person_id = person.values.id
          this.data.person = person
          this.relationshipForm.setValue(this.data)
        })
      }
    }

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Relatie bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u deze relatie wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('relationships', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor deze relatie.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    this.relationshipForm = new RelationshipForm(divContent, {relationship: this.data, onchange: this.onchange})

    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/relationship/action/EditRelationship.js